<template>
    <div class="container-evento ts-res">
  <v-app class="ts-res-app">

    <!-- PASOS (decorativo) -->
    <ol class="ts-res-pasos">
      <li class="ts-res-paso ts-res-paso--hecho">
        <span class="ts-res-paso-num"><i class="material-icons">check</i></span>
        <span class="ts-res-paso-txt">Carrito</span>
      </li>
      <li class="ts-res-paso ts-res-paso--hecho">
        <span class="ts-res-paso-num"><i class="material-icons">check</i></span>
        <span class="ts-res-paso-txt">Datos</span>
      </li>
      <li class="ts-res-paso ts-res-paso--hecho">
        <span class="ts-res-paso-num"><i class="material-icons">check</i></span>
        <span class="ts-res-paso-txt">Pago</span>
      </li>
      <li class="ts-res-paso ts-res-paso--activo">
        <span class="ts-res-paso-num">4</span>
        <span class="ts-res-paso-txt">Confirmación</span>
      </li>
    </ol>

    <div class="ts-res-card">
      <!-- ESTADO -->
      <header class="ts-res-estado" :class="datos_compra.res_banco == 1 ? 'ts-res-estado--ok' : datos_compra.res_banco == 2 ? 'ts-res-estado--error' : 'ts-res-estado--pendiente'">
        <span class="ts-res-estado-icono">
          <i class="material-icons">{{ datos_compra.res_banco == 1 ? 'check' : datos_compra.res_banco == 2 ? 'close' : 'schedule' }}</i>
        </span>
        <h1 class="ts-res-titulo">Resumen transacción</h1>
        <div class="ts-res-badge-wrap">
          <span class="ts-res-badge ts-res-badge--ok" v-if="datos_compra.res_banco == 1">Aprobado</span>
          <span class="ts-res-badge ts-res-badge--error" v-if="datos_compra.res_banco == 2">Rechazado</span>
          <span class="ts-res-badge ts-res-badge--pendiente" v-if="datos_compra.res_banco == 0">Pendiente Aprobación</span>
        </div>
        <p class="ts-res-sub" v-if="datos_compra.res_banco == 1">Tu pago fue aprobado. Recibirás tus boletas en tu correo electrónico.</p>
        <p class="ts-res-sub" v-if="datos_compra.res_banco == 2">El banco rechazó la transacción. Puedes intentar nuevamente con otro método de pago.</p>
        <p class="ts-res-sub" v-if="datos_compra.res_banco == 0">Tu pago está en proceso de aprobación por parte del banco.</p>
      </header>

      <!-- DATOS DE LA TRANSACCION -->
      <section class="ts-res-bloque">
        <h2 class="ts-res-bloque-titulo"><i class="material-icons">receipt</i> Datos de la transacción</h2>
        <dl class="ts-res-datos">
          <div class="ts-res-dato">
            <dt>Orden</dt>
            <dd class="ts-res-mono">{{ datos_compra.orden }}</dd>
          </div>
          <div class="ts-res-dato">
            <dt>Nombre Cliente</dt>
            <dd>{{ datos_compra.nombre_cliente }}</dd>
          </div>
          <div class="ts-res-dato">
            <dt>Id de venta</dt>
            <dd>{{ datos_compra.id_venta }}</dd>
          </div>
          <div class="ts-res-dato">
            <dt>Fecha transacción</dt>
            <dd>{{ datos_compra.fecha_transaccion }}</dd>
          </div>
          <div class="ts-res-dato">
            <dt>Referencia orden</dt>
            <dd class="ts-res-mono">{{ datos_compra.orden }}</dd>
          </div>
          <div class="ts-res-dato">
            <dt>Estado transacción</dt>
            <dd class="ts-res-capital">{{ datos_compra.estado_transaccion }}</dd>
          </div>
        </dl>
      </section>

      <!-- DETALLE DE MONTOS -->
      <section class="ts-res-bloque">
        <h2 class="ts-res-bloque-titulo"><i class="material-icons">account_balance_wallet</i> Detalle del pago</h2>
        <table class="ts-res-tabla" width="100%" cellspacing="0" cellpadding="0">
          <tr>
            <td>Subtotal compra</td>
            <td class="ts-res-valor">{{   currencyFormatDE(datos_compra.bs_subtotal, ',','.',true) + ' Bs.S' }}</td>
          </tr>
          <tr>
            <td>Servicio</td>
            <td class="ts-res-valor">{{   currencyFormatDE(datos_compra.bs_servicio, ',','.',true) + ' Bs.S' }}</td>
          </tr>
          <tr v-if="datos_compra.bs_impuesto > 0">
            <td>ISEP</td>
            <td class="ts-res-valor">{{   currencyFormatDE(datos_compra.bs_impuesto, ',','.',true) + ' Bs.S' }}</td>
          </tr>
          <tr v-if="datos_compra.bs_impuesto2 > 0">
            <td>IMP. MUNICIPAL</td>
            <td class="ts-res-valor">{{   currencyFormatDE(datos_compra.bs_impuesto2, ',','.',true) + ' Bs.S' }}</td>
          </tr>
          <tr v-if="datos_compra.bs_iva > 0">
            <td>IVA</td>
            <td class="ts-res-valor">{{   currencyFormatDE(datos_compra.bs_iva, ',','.',true) + ' Bs.S' }}</td>
          </tr>
        </table>

        <div class="ts-res-total">
          <div>
            <span class="ts-res-total-label">Total Compra</span>
            <strong class="ts-res-total-valor">{{  currencyFormatDE(datos_compra.bs_total, ',','.',true) + ' Bs.S' }}</strong>
          </div>
          <div class="ts-res-seguro">
            <b><i class="material-icons">lock</i> Pago seguro</b>
            <small>Tus datos están protegidos.</small>
          </div>
        </div>
      </section>

      <div class="ts-res-acciones">
        <button class="ts-res-btn-gold" @click="$router.push({path: '/'})">
          <i class="material-icons">home</i>&nbsp;Volver al inicio
        </button>
      </div>
    </div>

    </v-app>

    </div>

</template>
<script> 
 
import moment from "moment";
import { faSleigh } from "@fortawesome/free-solid-svg-icons";

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/l10n/es';
import 'flatpickr/dist/themes/material_blue.css'; 
import { asyncDispose } from 'core-js/fn/symbol';
import {configApi} from './../../../api/configApi'
import {headers} from './../../../api/headers'
import axios from 'axios'
moment.locale("es");

export default {
components: { 
 flatPickr, 
},
data() {
 return {
    datos_compra: {
                orden: '',
                res_banco: '',
                id_venta: '',
                fecha_transaccion: '',
                referencia_orden: '',
                estado_transaccion: '',
                subtotal_compra: '',
                total_compra: '',
                costo_transaccion: '',
                nombre_cliente: '',
                bs_subtotal: '',
                bs_servicio: '',
                bs_iva: '',
                bs_impuesto: '',
                bs_impuesto2: '',
                bs_total: '',
     
            },
   cambio_moneda: 'USD',
   type: 'month',
   start: new Date(),
   end: new Date(),
   typeOptions: [
     { text: 'Day', value: 'day' },
     { text: '4 Day', value: '4day' },
     { text: 'Week', value: 'week' },
     { text: 'Month', value: 'month' },
     { text: 'Custom Daily', value: 'custom-daily' },
     { text: 'Custom Weekly', value: 'custom-weekly' }
   ],
   selectedDate:  new Date(), 
   seleccionado: null,
   enabledDates: [ ],
   fechaselectedDate:'',
   seleccionadohora:'',
   menu: false, 
   acceptTyC: false,
   acceptTD: false,
   dialogotablaprecios: false,
   dataCompare: null,
   tab: "general",
   tabpreventa: 0,
   modalSelectEntregaBoletas: false,
   entregaBoletas: "digital",
   keyBoletasxLocalidad: 0,
   mostrarmapa: true,
   modalVisible: false,
   horario:[],  
   flatpickrStyle: {
     width: '500px',
     height: '70px',
   },
   name: '',
   cardNumber: '',
   expiration: '',
   security: '',
   translations: {
       name: {
           label: 'Nombre',
           placeholder: 'Nombre completo'
       },
       card: {
           label: 'Número de tarjeta',
           placeholder: 'Número de tarjeta'
       },
       expiration: {
           label: 'Expiration'
       },
       security: {
           label: 'Código de seguridad',
           placeholder: 'Código'
       }
   },
   
   
   keyPuntoventas: "",
   headersPuntoventa: [
     {
       text: "Nombre Comercial",
       align: "left",
       value: "punto_ventum.nombre_razon",
     },
     {
       text: "Dirección",
       value: "punto_ventum.direccion",
     },
     {
       text: "Ciudad",
       value: "punto_ventum.id_ciudad",
     },
     {
       text: "Zona/Region",
       value: "punto_ventum.zona",
     },
     {
       text: "Telefono",
       value: "punto_ventum.telefono",
     },
     {
       text: "Responsable",
       value: "punto_ventum.responsable",
     },
   ],
   divisaseleccionada: '$',
   rowperpageitems: [5, 10, 25, { text: "Todos", value: -1 }],
   idLocalidad: "",
   dialogmapasientos: false,
   elhtml2: "",
   monedaSelectShop: null, 
   activeModalAsientos: false, 
   datos_tarjeta: '',
   datos_p2p: '',
   datos_c2p: ''
 };
},
watch: {
 // evento(){
 //   this.$store.dispatch('auditorio_mapeado/listLocalidadesAuditorio_mapeado',this.evento.id_auditorio_mapeado);
 // },
 async evento() {
   this.$store.commit('evento/setImagenesEvento', null);
   if(this.evento){
     this.$store.dispatch(
       "evento/listPreventasEvento",
       this.evento.id
     );
     this.$store.dispatch(
       "auditorio_mapeado/listLocalidadesEventoAuditorioGeneral_mapeado",
       this.evento.id
     );
     await this.$store.dispatch("evento/changeMonedaShopEvento", {
       codigo_moneda: this.monedaSelectShopEvento,
       evento_id: this.evento.id,
     });
     this.$store.dispatch(
       "evento/getCondicionesEvento",
       this.evento.id
     );
     this.$store.dispatch(
       "evento/listPreventasEvento",
       this.evento.id
     );
     this.$store.dispatch(
       "evento/getpuntoventasEvento",
       this.evento.id
     );
     this.$store.dispatch(
       "auditorio_mapeado/listLocalidadesEventoAuditorio_mapeado",
       this.evento.id
     ); 
     this.mostrarmapa=true;
     if( this.evento.id_tipo_evento==7 ){
     this.mostrarmapa=false;
       }

     if (this.monedaSelectShopEvento === null && this.evento.monedas_evento.length > 0) {
       this.$store.commit(
         "evento/changeMonedaShopEvento",
         this.evento.monedas_evento[0].codigo_moneda
       );
       this.monedaSelectShop = this.monedaSelectShopEvento;
     } else {
       this.monedaSelectShop = this.monedaSelectShopEvento;
     }
     this.$store.dispatch("evento/getImagenesEvento", this.evento.id);
     $("html, body").animate({ scrollTop: $('body').offset().top }, 1);
     this.activeModalAsientos = false;
     if(this.evento && this.evento.slug != this.$route.params.evento){
       this.$store.dispatch(
         "auditorio_mapeado/listLocalidadesEventoAuditorio_mapeado",
         this.evento.id
       );
       this.$store.dispatch(
         "auditorio_mapeado/listLocalidadesEventoAuditorioGeneral_mapeado",
         this.evento.id
       );
     }
     if (this.idLocalidad && this.evento.localidades_evento) {
       let element = this.evento.localidades_evento.find(
         (e) => e.id_localidad == parseInt(this.idLocalidad)
       );
       if (!element) {
         this.idLocalidad = "";
       }
     }
    
     
   }
 },




},
async beforeCreate() {
 this.$store.dispatch("ciudad/listCiudades");
 await this.$store.dispatch("auditorio/listAuditorios");
 //await this.$store.dispatch("evento/getEvento", this.$route.params.evento);
 await this.$store.dispatch("evento/listEventosStatus", {
   page: 1,
   status: 1,
 });
 
  
},
async mounted() {

    await axios.get(configApi.apiUrl+'bnc/pagos/resumen/'+this.$route.params.token, headers)
        .then((response) => {    


                  //    console.log(response.data[0]);
            this.datos_compra.orden = response.data[0].token_refventa
            this.datos_compra.nombre_cliente = response.data[0].nombre + ' ' + response.data[0].apellidos
            this.datos_compra.res_banco = response.data[0].active
            this.datos_compra.id_venta = response.data[0].id
            this.datos_compra.fecha_transaccion = response.data[0].fecha
            this.datos_compra.referencia_orden =  response.data[0].token_refventa
            this.datos_compra.estado_transaccion = response.data[0].estado_entrega
            this.datos_compra.subtotal_compra = response.data[0].subtotal
            this.datos_compra.costo_transaccion = response.data[0].costo_transaccion
            this.datos_compra.total_compra =  response.data[0].total

            // Campos calculados en el backend como (suma en USD) * tasa
            this.datos_compra.bs_subtotal =  response.data[0].bs_subtotal1
            this.datos_compra.bs_servicio =  response.data[0].bs_servicio1
            this.datos_compra.bs_iva =  response.data[0].bs_iva1
            this.datos_compra.bs_impuesto =  response.data[0].bs_impuesto1
            this.datos_compra.bs_impuesto2 = response.data[0].bs_impuesto2
            this.datos_compra.bs_total = response.data[0].bs_total1
            


        }).catch((e) => {
          console.log(e)
        })   
        this.clearCantBoleta();


 $("html, body").animate({ scrollTop: $('body').offset().top }, 1);
 await this.onMounted();
 
 

},
beforeUpdate() {
   

 if (this.idLocalidad != "") {
   document.getElementsByClassName(
     "cont-mapa-asientos"
   )[0].style.backgroundImage = "";
 }
},

methods: {

  
  currencyFormatDE (
      num1,
      thousandsSeparator = ',',
      decimalSeparator = '.',
      showDecimals = false
    ) {

      let num =parseFloat(num1);
      let numero = 0;
      if (num) {
        numero = num
          .toFixed(showDecimals ? '2' : '0')
          .replace('.', decimalSeparator) // replace decimal point character with ,
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousandsSeparator}`)
      }
      return numero
    },

    formatNumber(number) {
        return new Intl.NumberFormat("es-CO", {
            minimumFractionDigits: 0,
        }).format(number);
        },
 async onMounted() {
   
   
   
 },

 async clearCantBoleta() {
   this.$store.state.carrito.descuentocupon = 0;
   this.$store.state.carrito.cuponestado =0;
   this.$store.state.carrito.vservicio =0;
   this.$store.state.carrito.cupon  = '';
   this.$store.state.carrito.cuponok=false
   this.$store.state.funcioneshora=[]; 
   if (this.preciosBoletasCarrito && this.preciosBoletasCarrito.length > 0) {
     var lasBoletas = [];
     var losPalcos = [];


       lasBoletas = JSON.parse(localStorage.getItem('newboletasclear'));
       losPalcos = JSON.parse(localStorage.getItem('newpalcosclear'));

     /*await this.$store.dispatch("carrito/setNullReservas", {
       boletas: lasBoletas,
       palcos: losPalcos,
     });*/

     localStorage.removeItem('newboletasclear'); 
     localStorage.removeItem('newpalcosclear');

     this.idLocalidad = "";
     this.$store.dispatch("evento/clearCantBoleta");
     this.$store.dispatch("carrito/setNullPreciosBoletasCarrito");
     this.$store.dispatch("carrito/dateTimeSaleStart", null);
     this.$store.dispatch("carrito/dateTimeSaleEnd", null);
     
     this.$store.state.showModalFinalizarCompra = false;
     localStorage.removeItem('estadoVuex');
    
   } else {
     var lasBoletas = [];
     var losPalcos = [];
     this.idLocalidad = "";
     this.$store.dispatch("evento/clearCantBoleta");
   
     localStorage.removeItem('estadoVuex');
     this.$store.state.showModalFinalizarCompra = false;
     
   }
 },
 



 concatTextMoneda(item) {
   return `(${item.moneda.simbolo}) ${item.moneda.descripcion}`;
 },
 


},
computed: {

 hoy() {
   return moment().format("Y-MM-DD");
 },
 cantBoleta() {
   return this.$store.getters["evento/cantBoleta"];
 },
 cantBoletaTotal() {
   return this.$store.getters["evento/cantBoletaTotal"];
 },
 ciudades() {
   return this.$store.getters["ciudad/listCiudades"];
 },
 evento() {
   return this.$store.getters["evento/evento"];
 },
 condicionesEvento() {
   return this.$store.getters["evento/condicionesEvento"];
 },
 preventasEvento() {
   return this.$store.getters["evento/listPreventasEvento"];
 },
 showEventosDestacados() {
   return this.$store.getters["evento/listEventosDestacados"];
 },
 eventosDestacados() {
   return this.showEventosDestacados.slice(0, 4);
 },
 imagenesEvento() {
   return this.$store.getters["evento/imagenesEvento"];
 },
 userAuth() {
   return this.$store.getters["user/dataUserLogged"];
 },
 puntoventasEvento() {
   return this.$store.getters["evento/puntoventasEvento"];
 },
 
 listLocalidadesEventoAuditorio_mapeado() {
   return this.$store.getters[
     "auditorio_mapeado/listLocalidadesEventoAuditorio_mapeado"
   ];
 },

 imagenesEventoCarousel() {
   let imagenesEventoCarouselShow = [];
   if (this.imagenesEvento) {
     imagenesEventoCarouselShow = this.imagenesEvento.filter((imagen) => {
       return imagen.imagen.nombre.includes("banner");
     });
   }
   return imagenesEventoCarouselShow;
 },
 monedaSelectShopEvento() {
   return this.$store.getters["evento/monedaSelectShop"];
 },
 indexMonedaSelectShopEvento() {
   if (this.evento.monedas_evento && this.evento.monedas_evento.length > 0) {
     var index = this.evento.monedas_evento.findIndex(
       (moneda) => moneda.codigo_moneda === this.monedaSelectShopEvento
     );
     if (index === 0) {
       return "";
     } else {
       return index + 1;
     }
   }
 },
 simboloMoneda() {
   if (
     this.indexMonedaSelectShopEvento === "" ||
     this.indexMonedaSelectShopEvento === 0
   ) {
     return this.evento ? this.evento.monedas_evento[0].moneda.simbolo : ''
   } else {
     return this.evento ? this.evento.monedas_evento[this.indexMonedaSelectShopEvento - 1] : ''
       .moneda.simbolo;
   }
 },
 preciosBoletasCarrito() {
   return this.$store.getters["carrito/preciosBoletasCarrito"];
 },
 totalValorBoletasCarrito() {
   var preciosBoletasCarritoMonedaActual = this.$store.getters[
     "carrito/preciosBoletasCarrito"
   ].filter((item) => item.codigo_moneda == this.monedaSelectShopEvento);
   if (
     preciosBoletasCarritoMonedaActual &&
     preciosBoletasCarritoMonedaActual.length > 0
   ) {
     var total = 0;
     for (
       var i = preciosBoletasCarritoMonedaActual.length - 1;
       i >= 0;
       i--
     ) {
       total += preciosBoletasCarritoMonedaActual[i].precio;
     }
     return this.formatNumber(total);
   } else {
     return 0;
   }
 },
 localidadSelectCarrito() {
   return this.$store.getters["carrito/localidadSelectCarrito"];
 },
 countBoletas() {
   return this.$store.getters["carrito/countBoletas"];
    
 },
 countPalcos() {
   return this.$store.getters["carrito/countPalcos"];
   
 },
 dateTimeSaleStart() {
   return this.$store.getters["carrito/dateTimeSaleStart"];
 },
 dateTimeSaleEnd() {
   return this.$store.getters["carrito/dateTimeSaleEnd"];
 },

},
};
</script>
<style>
.container-payment{
    width: 100vw;
    height: 100vh;
    max-width: 1600px;
    margin-right: auto;
    margin-left: auto;
    margin-bottom: auto;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    align-content: flex-start;
}
.tabla_resumen{
    widows: 100%;
    margin-right: auto;
    margin-left: auto;
    
	border: 1px solid #CCCCCC;
    border-radius: 10px;
}
.tabla_resumen tr td{
    font-family:Verdana;
}
</style>

<style>
/* ===== Rediseño visual del resumen de transacción (solo estilos) ===== */
.ts-res,
.ts-res .ts-res-app,
.ts-res .ts-res-app .v-application--wrap {
  background: #f3f2ef !important;
}
.ts-res .v-application--wrap {
  min-height: auto !important;
  padding: 28px 16px 4rem;
}
.ts-res *:not(.material-icons):not(.v-icon):not(.mdi) {
  font-family: 'Montserrat', Raleway, sans-serif;
}

/* Pasos */
.ts-res-pasos {
  list-style: none;
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 760px;
  margin: 0 auto 26px;
  padding: 0;
}
.ts-res-paso {
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #555;
  font-size: 15px;
}
.ts-res-paso::before {
  content: '';
  position: absolute;
  top: 21px;
  right: 50%;
  width: 100%;
  height: 2px;
  background: #8a8a8a;
}
.ts-res-paso:first-child::before {
  display: none;
}
.ts-res-paso--activo::before {
  background: linear-gradient(90deg, #8a8a8a 0%, #c8962e 60%);
}
.ts-res-paso-num {
  position: relative;
  z-index: 1;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #7d7d7d;
  color: #fff;
  font-weight: 700;
  font-size: 17px;
}
.ts-res-paso--activo {
  color: #111;
  font-weight: 700;
}
.ts-res-paso--activo .ts-res-paso-num {
  background: #c8962e;
  box-shadow: 0 4px 12px rgba(200, 150, 46, .4);
}

/* Tarjeta */
.ts-res-card {
  width: 100%;
  max-width: 760px;
  margin: 0 auto;
  background: #fff;
  border: 1px solid #ebe8e1;
  border-radius: 14px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, .06);
  overflow: hidden;
}

/* Estado */
.ts-res-estado {
  text-align: center;
  padding: 32px 24px 26px;
  background: #111 url('/images/fondo-menu-ve.jpg') center / cover no-repeat;
  color: #fff;
  border-bottom: 3px solid #d4a537;
}
.ts-res-estado-icono {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  margin-bottom: 12px;
  color: #fff;
}
.ts-res-estado-icono .material-icons {
  font-size: 38px;
}
.ts-res-estado--ok .ts-res-estado-icono {
  background: #2e9e44;
  box-shadow: 0 0 0 6px rgba(46, 158, 68, .25);
}
.ts-res-estado--error .ts-res-estado-icono {
  background: #e53935;
  box-shadow: 0 0 0 6px rgba(229, 57, 53, .25);
}
.ts-res-estado--pendiente .ts-res-estado-icono {
  background: #c8962e;
  box-shadow: 0 0 0 6px rgba(200, 150, 46, .25);
}
.ts-res .ts-res-titulo {
  font-family: 'Oswald', sans-serif !important;
  font-size: 32px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .5px;
  color: #fff;
  margin: 0 0 10px;
}
.ts-res-badge {
  display: inline-block;
  padding: 5px 16px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .5px;
}
.ts-res-badge--ok {
  background: #2e9e44;
  color: #fff;
}
.ts-res-badge--error {
  background: #e53935;
  color: #fff;
}
.ts-res-badge--pendiente {
  background: linear-gradient(180deg, #f6dc8c 0%, #d4a537 55%, #b8862a 100%);
  color: #1a1a1a;
}
.ts-res .ts-res-sub {
  margin: 12px auto 0;
  max-width: 460px;
  font-size: 14px;
  color: #ddd;
}

/* Bloques */
.ts-res-bloque {
  padding: 24px 28px 4px;
}
.ts-res .ts-res-bloque-titulo {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 700;
  text-transform: uppercase;
  color: #1a1a1a;
  margin: 0 0 14px;
}
.ts-res-bloque-titulo .material-icons {
  color: #c8962e;
  font-size: 22px;
}
.ts-res-datos {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 24px;
  margin: 0;
}
.ts-res-dato {
  background: #faf9f6;
  border: 1px solid #f0ede5;
  border-radius: 10px;
  padding: 10px 14px;
  min-width: 0;
}
.ts-res-dato dt {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .5px;
  color: #888;
  margin-bottom: 3px;
}
.ts-res-dato dd {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #111;
  word-break: break-all;
}
.ts-res-capital {
  text-transform: capitalize;
}
.ts-res-tabla td {
  padding: 11px 4px;
  border-bottom: 1px solid #f0ede5;
  font-size: 14px;
  color: #444;
  text-align: left;
}
.ts-res-tabla td.ts-res-valor {
  text-align: right;
  white-space: nowrap;
  font-weight: 600;
  color: #111;
}
.ts-res-total {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 16px;
  background: #faf9f6;
  border: 1px solid #ebe8e1;
  border-left: 4px solid #c8962e;
  border-radius: 12px;
  padding: 18px 24px;
}
.ts-res-total-label {
  display: block;
  font-size: 15px;
  font-weight: 600;
  color: #666;
  text-align: left;
}
.ts-res-total-valor {
  display: block;
  font-size: 30px;
  font-weight: 700;
  color: #111;
  line-height: 1.2;
}
.ts-res-seguro {
  text-align: right;
}
.ts-res-seguro b {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  font-size: 15px;
  color: #222;
}
.ts-res-seguro .material-icons {
  color: #2e9e44;
  font-size: 21px;
}
.ts-res-seguro small {
  color: #777;
  font-size: 13px;
}

/* Acciones */
.ts-res-acciones {
  display: flex;
  justify-content: center;
  padding: 24px 28px 30px;
}
.ts-res-btn-gold {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #f6dc8c 0%, #d4a537 55%, #b8862a 100%);
  color: #1a1a1a;
  font-family: 'Oswald', sans-serif !important;
  font-weight: 600;
  font-size: 18px;
  text-transform: uppercase;
  letter-spacing: 1px;
  border: 0;
  border-radius: 999px;
  padding: 12px 36px;
  box-shadow: 0 6px 18px rgba(212, 165, 55, .35);
  cursor: pointer;
  transition: transform .2s, box-shadow .2s;
}
.ts-res-btn-gold:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 24px rgba(212, 165, 55, .5);
}
.ts-res-btn-gold .material-icons {
  font-size: 20px;
}

@media (max-width: 600px) {
  .ts-res .v-application--wrap {
    padding: 20px 10px 3rem;
  }
  .ts-res-paso {
    font-size: 12px;
  }
  .ts-res-paso-num {
    width: 36px;
    height: 36px;
    font-size: 14px;
  }
  .ts-res-paso::before {
    top: 17px;
  }
  .ts-res .ts-res-titulo {
    font-size: 24px;
  }
  .ts-res-bloque {
    padding: 20px 16px 4px;
  }
  .ts-res-datos {
    grid-template-columns: 1fr;
  }
  .ts-res-total {
    padding: 16px;
  }
  .ts-res-total-valor {
    font-size: 24px;
  }
  .ts-res-seguro {
    text-align: left;
  }
  .ts-res-seguro b {
    justify-content: flex-start;
  }
  .ts-res-acciones {
    padding: 20px 16px 24px;
  }
  .ts-res-btn-gold {
    width: 100%;
  }
}
</style>
